import { ColumnModel, Column } from "@syncfusion/ej2-react-grids";
import { BoltTaskStatuses } from "@bolt/core";
import { DueInComponent } from "../../DueInField/DueInComponent";
import { utils } from "@ucl/library";

interface DueInGridColumnProps extends ColumnModel {
  alwaysCalculateDueIn?: boolean;
}

export class DueInGridColumn extends Column {
  constructor(opts: DueInGridColumnProps) {
    super({
      ...opts,
      template: ((model: Record<string, any>) => {
        const modelValue: number =
          opts.alwaysCalculateDueIn === true || !opts.field
            ? model.dueDate
              ? utils.date.calculateSecondsFromUtcNow(model.dueDate)
              : 0
            : opts.field
            ? Number(model[opts.field])
            : 0;

        const status = model.taskStatus as BoltTaskStatuses;
        return <DueInComponent dueIn={modelValue} status={status} />;
      }) as any,
    });
  }
}
